import {Vue} from "ui.vue";
import {VueYandexMetrika} from "./helpers";

VueYandexMetrika.install = function (Vue, options) {
    Vue.metrika = new VueYandexMetrika()

    options = {
        id: process.env.YA_ID,
        debug: process.env.DEBUG,
        env: process.env.NODE_ENV,
        options: {
            ecommerce: process.env.YA_ECOMMERCE ?? false,
        }
    };

    // Merge options and default config
    Vue.metrika.updateConfig(options)
    // Check if all required options are presented
    Vue.metrika.checkConfig()
	// Create debug metrika
	Vue.metrika.createMockMetrika(Vue);
    // Load Metrika script
    Vue.metrika.loadScript(() => {
        // Create Metrika
        const metrika = Vue.metrika.createMetrika(Vue)
        // Start auto tracking
        Vue.metrika.startTracking(metrika)
    }, options.scriptSrc)
}


Vue.use(VueYandexMetrika);

export {VueYandexMetrika};
export default VueYandexMetrika;
